/**
 * Submission filters component.
 *
 * @module SubmissionFilters
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SubmissionFiltersProps {
  filterExamType: string;
  setFilterExamType: (value: string) => void;
  filterModule: string;
  setFilterModule: (value: string) => void;
  filterGraded: string;
  setFilterGraded: (value: string) => void;
  filterCompletion: string;
  setFilterCompletion: (value: string) => void;
  onRefresh: () => void;
}

export function SubmissionFilters({
  filterExamType,
  setFilterExamType,
  filterModule,
  setFilterModule,
  filterGraded,
  setFilterGraded,
  filterCompletion,
  setFilterCompletion,
  onRefresh,
}: Readonly<SubmissionFiltersProps>) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-ui text-lg">Filters</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div>
            <Label htmlFor="exam-type" className="font-ui">Exam Type</Label>
            <Select value={filterExamType} onValueChange={setFilterExamType}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Types</SelectItem>
                <SelectItem value="goethe">Goethe</SelectItem>
                <SelectItem value="ösd">ÖSD</SelectItem>
                <SelectItem value="telc">TELC</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="module" className="font-ui">Module</Label>
            <Select value={filterModule} onValueChange={setFilterModule}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Modules</SelectItem>
                <SelectItem value="reading">Reading</SelectItem>
                <SelectItem value="listening">Listening</SelectItem>
                <SelectItem value="writing">Writing</SelectItem>
                <SelectItem value="speaking">Speaking</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="graded" className="font-ui">Grading Status</Label>
            <Select value={filterGraded} onValueChange={setFilterGraded}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                <SelectItem value="graded">Graded</SelectItem>
                <SelectItem value="ungraded">Ungraded</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="completion" className="font-ui">Completion Status</Label>
            <Select
              value={filterCompletion}
              onValueChange={setFilterCompletion}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                <SelectItem value="complete">Complete</SelectItem>
                <SelectItem value="incomplete">Incomplete</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-end">
            <Button onClick={onRefresh} variant="outline" className="w-full">
              <span className="font-ui">Refresh</span>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
